import { useTranslation } from 'react-i18next'

import { REQUEST_ENTITY } from '../../../constants/entity'
import { REQUEST_STATUS } from '../../../constants/request'
import { ScreenContainerRef } from '../../../context'
import { useUk } from '../../../hooks'
import { FilterDivider } from '../../FilterDivider'
import { PageActions } from '../../Page'
import { Pagination } from '../../Pagination'
import { SelectionToolbar } from '../../SelectionToolbar'
import {
  getSelectedSize,
  getTableResetSortingButton,
  Table,
  TableConfigModal,
  TableContext,
  TableControlBar,
  TableControlButtons,
  TableMassAction,
} from '../../Table'
import { getItemActions } from '../Request.utils.actions'
import { RequestTableRow } from '../RequestTableRow'

function RequestTableLayout({
  ChangeViewTypeButton = null,
  arrowNavigationConfig,
  changeViewTypeButtonProps,
  emptyState = null,
  entity = REQUEST_ENTITY,
  extraModals = null,
  hasTable,
  isTableSkeleton = false,
  modal = null,
  rowExtraProps,
  tablePage,
  onChangeFocusedRow,
}) {
  const {
    availableSections,
    canConnectDocFlow,
    canCreateDocFlow,
    checkIsItemSelected,
    columnResizeConfig,
    columns,
    docFlowTagModal,
    exclude,
    extra,
    handleApply,
    handleChangeVisibility,
    handleClickDocFlowTag,
    handleClickEmailTag,
    handleClickFileTag,
    handleClickLinkedRequestTag,
    handleClickRow,
    handleConfigOpen,
    handleDensityChange,
    handleExclude,
    handleMouseDownRow,
    handleResetOrdering,
    handleSelect,
    handleSelectAll,
    handleSelectAllPages,
    handleSetColumns,
    handleSetOrdering,
    handleSetPagination,
    handleSetSize,
    handleUnselectAllPages,
    isAllSelected,
    isConfigOpen,
    isDense,
    isLoading,
    isRemoveSelection,
    items,
    massActions,
    ordering,
    pageScrollWrapperRef,
    pagination,
    refreshButtonProps,
    requiredColumns,
    selectAllPages,
    selected,
    setConfigOpen,
    setItemAction,
    setMassAction,
    tagModal,
  } = tablePage

  const { t } = useTranslation()

  const { config: ukConfig } = useUk()

  function getActions(item) {
    return getItemActions({
      canConnectDocFlow,
      canCreateDocFlow,
      item,
      t,
      ukConfig,
    })
  }

  return (
    <>
      {hasTable ? (
        <>
          <TableControlBar>
            <TableMassAction
              responsive
              actions={massActions}
              isAllSelected={isAllSelected}
              isLoading={isLoading}
              isRemoveSelection={isRemoveSelection}
              selectedSize={getSelectedSize({
                exclude,
                pagination,
                selectAllPages,
                selected,
              })}
              setMassAction={setMassAction}
              onSelectAll={handleSelectAll}
            />
            <PageActions isLoading={isLoading}>
              <TableControlButtons
                ChangeViewTypeButton={ChangeViewTypeButton}
                ResetSortingButton={getTableResetSortingButton(ordering)}
                changeViewTypeButtonProps={changeViewTypeButtonProps}
                configButtonProps={{ onClick: handleConfigOpen }}
                densityButtonProps={{ isDense, onClick: handleDensityChange }}
                refreshButtonProps={refreshButtonProps}
                resetSortingProps={{ onClick: handleResetOrdering }}
              />
              <FilterDivider />
              <Pagination
                responsive
                value={pagination}
                onChange={handleSetPagination}
                onChangeSize={handleSetSize}
              />
            </PageActions>
          </TableControlBar>
          <Table
            TableRow={RequestTableRow}
            arrowNavigationConfig={arrowNavigationConfig}
            checkIsItemSelected={checkIsItemSelected}
            columns={columns}
            containerRef={pageScrollWrapperRef}
            context={TableContext.Request}
            headerRowProps={{
              columnResizeConfig,
              ordering,
              onApply: handleApply,
              onSetColumns: handleSetColumns,
              onSetOrdering: handleSetOrdering,
            }}
            isLoading={isLoading || isTableSkeleton}
            items={isTableSkeleton ? null : items && items.items}
            rowProps={{
              ...rowExtraProps,
              availableSections,
              extra,
              getActions,
              hideCheckbox: massActions.length === 0,
              isShort: isDense,
              statuses: REQUEST_STATUS,
              onCallAction: setItemAction,
              onChangeVisibility: handleChangeVisibility,
              onClick: rowExtraProps?.onClick ?? handleClickRow,
              onClickDocFlowTag: handleClickDocFlowTag,
              onClickEmailTag: handleClickEmailTag,
              onClickFileTag: handleClickFileTag,
              onClickRequestTag: handleClickLinkedRequestTag,
              onMouseDown: rowExtraProps?.onMouseDown ?? handleMouseDownRow,
              onSelect: selectAllPages ? handleExclude : handleSelect,
            }}
            onChangeFocusedRow={onChangeFocusedRow}
          />
        </>
      ) : (
        emptyState
      )}
      {selected.length > 0 || selectAllPages ? (
        <SelectionToolbar
          allSelected={selectAllPages || selected.length === pagination.count}
          count={pagination.count}
          excludeCount={exclude.length}
          selected={selected.length}
          onClose={handleUnselectAllPages}
          onSelectAll={handleSelectAllPages}
        />
      ) : null}
      {isConfigOpen ? (
        <TableConfigModal
          columns={columns}
          entity={entity}
          requiredColumns={requiredColumns}
          setColumns={handleSetColumns}
          setConfigOpen={setConfigOpen}
          onApply={handleApply}
        />
      ) : null}
      <ScreenContainerRef value={null}>
        {tagModal}
        {docFlowTagModal}
        {modal}
        {extraModals}
      </ScreenContainerRef>
    </>
  )
}

export default RequestTableLayout
